import { render, staticRenderFns } from "./plan-list.vue?vue&type=template&id=3ab4318c&"
import script from "./plan-list.vue?vue&type=script&lang=js&"
export * from "./plan-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports